<template>
  <section class="section levelClaimed" :class="{open: show}">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
          <h4>Hadiah sudah di klaim</h4>
        </div>
        <div class="contentSc">
          <div class="menuCnt">
            <div class="menuItem loadingPrice" v-if="loading"></div>
            <div v-else>
              <div :class="{menuItem: true, locked: point < item.point}"
                v-for="(item, i) in price" :key="i">
                <div class="menuIcon" :class="item.icon"></div>
                <div>
                  {{item.name}}
                  <p class="p2">Hadiah di <b>{{item.point.toLocaleString('id')}}pt</b></p>
                  <p v-if="item.description && item.description !== ''">{{item.description}}</p>
                </div>
                <div :class="{claim: true, claimed: item.claimed}"
                  v-on:click="claim(item, i)">
                  <span v-if="item.claimed">Claimed</span>
                  <span v-else>Claim</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: { Confirmation },
  data() {
    return {
      point: 9999999,
      loading: true,
      price: [],
      show: false,
    };
  },
  methods: {
    doNothing() {},
    open() {
      this.show = true;
      this.loading = true;
      this.getData();
    },
    close() {
      this.show = false;
    },
    claim() {},
    getData() {
      this.$http.get(this.$config.uri('user/price?claimed=y')).then((r) => {
        this.loading = false;
        this.price = (r.data.status === 200) ? r.data.data : [];
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.section.levelClaimed{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;
    background-color: #e6e1c1;
    padding: 0 0 40px;
    box-sizing: border-box;
    width: 400px;
    z-index: 3;
    right: -400px;
    transition: all .45s ease;
    @media (max-width: 768px) {
      top: 60px;
    }
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      background-image: url(../assets/high-five.png);
      background-size: auto 160px;
      background-position: right bottom;
      background-repeat: no-repeat;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    position: relative;
    padding: 5px 20px;
    z-index: 7;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    backdrop-filter: blur(20px);
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 18px;
      margin: 0;
      color: #444;
      position: absolute;
      left: 80px; top: 13px; right: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .contentSc{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    overflow-y: auto;
    z-index: 5;
    padding: 65px 10px 10px;
  }
  .menuCnt{
    padding: 0 0 40px;
    h4{
      margin: 0 20px 6px;
    }
    .divider{
      height: 20px;
    }
    .menuItem{
      padding: 16px 20px;
      padding-left: 90px;
      padding-right: 106px;
      font-weight: bold;
      color: #444;
      position: relative;
      background-color: rgba(255, 255, 255, .75);
      backdrop-filter: blur(20px);
      // background-image: linear-gradient(to left, #8EC642, #669922);
      // color: #fff;
      margin: 0 10px 10px;
      border-radius: 5px;
      font-size: 17px;
      min-height: 80px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      &.loadingPrice{
        background-color: rgba(255, 255, 255, 0.5);
        background-color: transparent;
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 36px auto;
        height: 60px;
      }
      &.allClaimed{
        background-color: rgba(255, 255, 255, 0.5);
        padding: 10px 20px;
        min-height: 0;
        &:active{
          background-color: #ddd;
        }
        .more{
          position: absolute;
          right: 12px; top: 10px;
          width: 20px; height: 20px;
          background-position: center;
          background-size: 16px auto;
          background-repeat: no-repeat;
          background-image: url(../assets/arrow-right-black.png);
          opacity: .3;
        }
      }
      p{
        font-size: 14px;
        margin: 0;
        font-weight: normal;
        &.p2{
          color: #767676;
          font-size: 13px;
          margin: 2px 0 0;
        }
      }
      .claim{
        position: absolute;
        right: 12px; top: 50%;
        transform: translateY(-50%);
        background-position: center;
        background-size: 16px auto;
        background-repeat: no-repeat;
        background-color: #8EC642;
        padding: 6px 14px;
        border-radius: 50px;
        color: #fff;
        font-size: 14px;
        font-weight: normal;
        &:active{
          background-color: #006519;
        }
        &.claimed{
          background-color: #ddd;
          color: #999;
        }
      }
      .menuIcon{
        position: absolute;
        left: 14px; top: 10px;
        width: 60px; height: 60px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #8EC642;
        background-color: #cdf992;
        background-color: #d5f4e8;
        background-color: #eee;
        border-radius: 10px;
        &.badut-atas{
          background-image: url(../assets/acc-thumb/thumb-atas-badut.png);
        }
        &.indo-atas{
          background-image: url(../assets/acc-thumb/thumb-atas-indo.png);
        }
        &.gym-atas{
          background-image: url(../assets/acc-thumb/thumb-atas-gym.png);
        }
        &.sekolah-atas{
          background-image: url(../assets/acc-thumb/thumb-atas-sekolah.png);
        }
        &.farmer-atas{
          background-image: url(../assets/acc-thumb/thumb-atas-petani.png);
        }
        &.gym2-atas{
          background-image: url(../assets/acc-thumb/thumb-atas-gym2.png);
        }
        &.bodykey-atas{
          background-image: url(../assets/acc-thumb/thumb-atas-bk.png);
        }
        &.lab-atas{
          background-image: url(../assets/acc-thumb/thumb-atas-lab.png);
        }
        &.acc-indo2-1-atas{
          background-image: url(../assets/acc-thumb/thumb-indo2-atas.png);
        }
        &.acc-paskib-1-atas{
          background-image: url(../assets/acc-thumb/thumb-paskib1-atas.png);
        }
        &.acc-pahlawan-1-atas{
          background-image: url(../assets/acc-thumb/thumb-hero1-atas.png);
        }
        &.acc-AI30-1-atas{
          background-image: url(../assets/acc-thumb/thumb-AI30-1-atas.png);
        }
        &.acc-astro-1{
          background-image: url(../assets/acc-thumb/thumb-astro.png);
        }

        &.badut-tengah{
          background-image: url(../assets/acc-thumb/thumb-tengah-badut.png);
        }
        &.indo-tengah{
          background-image: url(../assets/acc-thumb/thumb-tengah-indo.png);
        }
        &.gym-tengah{
          background-image: url(../assets/acc-thumb/thumb-tengah-gym.png);
        }
        &.sekolah-tengah{
          background-image: url(../assets/acc-thumb/thumb-tengah-sekolah.png);
        }
        &.farmer-tengah{
          background-image: url(../assets/acc-thumb/thumb-tengah-petani.png);
        }
        &.gym2-tengah{
          background-image: url(../assets/acc-thumb/thumb-tengah-gym2.png);
        }
        &.lab-tengah{
          background-image: url(../assets/acc-thumb/thumb-tengah-lab.png);
        }
        &.bodykey-tengah{
          background-image: url(../assets/acc-thumb/thumb-tengah-bk.png);
        }
        &.acc-indo2-1-tengah{
          background-image: url(../assets/acc-thumb/thumb-indo2-tengah.png);
        }
        &.acc-paskib-1-tengah{
          background-image: url(../assets/acc-thumb/thumb-paskib1-tengah.png);
        }
        &.acc-pahlawan-1-tengah{
          background-image: url(../assets/acc-thumb/thumb-hero1-tengah.png);
        }
        &.acc-AI30-1-tengah{
          background-image: url(../assets/acc-thumb/thumb-AI30-1-tengah.png);
        }
        &.acc-astro-1{
          background-image: url(../assets/acc-thumb/thumb-astro.png);
        }

        &.badut-bawah{
          background-image: url(../assets/acc-thumb/thumb-bawah-badut.png);
        }
        &.indo-bawah{
          background-image: url(../assets/acc-thumb/thumb-bawah-indo.png);
        }
        &.gym-bawah{
          background-image: url(../assets/acc-thumb/thumb-bawah-gym.png);
        }
        &.sekolah-bawah{
          background-image: url(../assets/acc-thumb/thumb-bawah-sekolah.png);
        }
        &.farmer-bawah{
          background-image: url(../assets/acc-thumb/thumb-bawah-petani.png);
        }
        &.gym2-bawah{
          background-image: url(../assets/acc-thumb/thumb-bawah-gym2.png);
        }
        &.bodykey-bawah{
          background-image: url(../assets/acc-thumb/thumb-bawah-bk.png);
        }
        &.lab-bawah{
          background-image: url(../assets/acc-thumb/thumb-bawah-lab.png);
        }
        &.acc-indo2-1-bawah{
          background-image: url(../assets/acc-thumb/thumb-indo2-bawah.png);
        }
        &.acc-paskib-1-bawah{
          background-image: url(../assets/acc-thumb/thumb-paskib1-bawah.png);
        }
        &.acc-pahlawan-1-bawah{
          background-image: url(../assets/acc-thumb/thumb-hero1-bawah.png);
        }
        &.acc-AI30-1-bawah{
          background-image: url(../assets/acc-thumb/thumb-AI30-1-bawah.png);
        }
        &.acc-astro-1{
          background-image: url(../assets/acc-thumb/thumb-astro.png);
        }

        &.bg2{
          background-image: url(../assets/bg-2.png);
          background-size: cover;
        }
        &.bg3{
          background-image: url(../assets/bg-3.png);
          background-size: cover;
        }
        &.custombg{
          background-image: url(../assets/image-gallery.png);
          background-size: 60%;
        }
        &.finisher{
          background-image: url(../assets/finisher-hadiah.png);
          // background-size: 80%;
        }
      }
      &.locked{
        .menuIcon{
          filter: grayscale(1);
        }
        .claim{
          background-color: #006519;
          background-image: url(../assets/locked.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          span{
            visibility: hidden;
          }
        }
      }
    }
  }
}
</style>
